module.exports = __webpack_public_path__ + "static/weronikawork5-9252a2b66e87653b95885e5aec312e64.jpg";